import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { changePlan_currentAccountQuery as CurrentAccountQuery } from './types/changePlan_currentAccountQuery';

export const currentAccountQuery = gql`
  query changePlan_currentAccountQuery($accountId: Int!) {
    account(id: $accountId) {
      companyName
      id
      name
      owner {
        id
        email
      }
      featureEnrollmentList {
        id
        featureName
        isEnrolled
      }
      switches
    }
  }
`;

type Options = {
  skip?: boolean;
};

export const useCurrentAccount = (accountId: number, options: Options = {}) => {
  const { data, error, loading } = useQuery<CurrentAccountQuery>(
    currentAccountQuery,
    {
      fetchPolicy: 'network-only',
      skip: Boolean(options?.skip),
      variables: { accountId },
    }
  );

  return {
    currentAccount: data?.account,
    error: error
      ? 'There was an issue loading account data. Please try again.'
      : null,
    isLoading: loading,
  };
};
